import Vue from 'vue'
import VueRouter from 'vue-router'
import Configurador from '../views/Configurador.vue'
import Parent from '../views/Parent.vue'
import Motors from '../views/Motors'
import Version from '../views/Version'
import DesignExterior from '../views/DesignExterior'
import DesignInterior from '../views/DesignInterior'
import Resume from '../views/Resume'
import Comparator from '../views/Comparator'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Configurador',
    component: Configurador,
    props:{ id:0},
  },
  {
    path: '/:model',
    name: 'Parent',
    component: Parent,
    children: [
      {
        path: 'motor',
        name: 'Motors',
        component: Motors,
        props:{ id:1},
      },
      {
        path: 'versao',
        name: 'Version',
        component: Version,
        props:{ id:2},
      },
      {
        path: 'exterior',
        name: 'DesignExterior',
        component: DesignExterior,
        props:{ id:3},
      },
      {
        path: 'interior',
        name: 'DesignInterior',
        component: DesignInterior,
        props:{ id:4},
      },
      {
        path: 'resumo',
        name: 'Resume',
        component: Resume,
        props:{ id: 5},
      },
      {
        path: 'comparador',
        name: 'Comparator',
        component: Comparator,
        props:{ id: 6},
        beforeEnter: (to, from, next) => {
          // console.log(to);
          const { params } = to
          // console.log(params);
          Object.keys(params).length > 1 ? next() : next('/')
        }
      },
    ]
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    component: Configurador,
  }
]

const router = new VueRouter({
    base: process.env.VUE_APP_BASE,
    mode: 'history',
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (to.hash) {
        return {el: to.hash}
      }

      if (savedPosition) {
        return savedPosition;
      } else {
        return { left: 0, top: 0 };
      }
    },
  })

  router.beforeEach(function (to, from, next) {

    if(!to.path.includes(from.path)){
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    }
    next();
  });

  export default router
